import { put, call, take } from 'redux-saga/effects';

import { INSURANCE_FLOW_TYPE } from '../../../constants/insurance-flow-type';

import {
  actions as editUserActions,
  consts as editUserConsts,
} from '../../profiles/edit-user';

export function* editUserAfterInsuranceUpdate(payload) {
  const { userId, skipInsurance, finishAction, flowType } = payload;

  yield put(
    editUserActions.send({
      id: userId,
      skipInsurance,
    }),
  );

  yield take(editUserConsts.SUCCEED);

  if ([INSURANCE_FLOW_TYPE.PAPERWORK].includes(flowType)) {
    yield put(editUserActions.clear());
  }

  if (finishAction) {
    yield call(finishAction);
  }
}



// WEBPACK FOOTER //
// ./src/redux/manage-insurances/sagas/edit-user-after-insurance-update.js